import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';
import { AvailableEntityFolderTypes } from '@/services/api/resources/entityFolder/types';

export type availableEntityFolderQueryType = AvailableEntityFolderTypes;

export interface EntityFolderQuery {
  search: string;
  entityItem: number[];
  user: number[];
  label: number[];
}

export interface ListAvailableEntityFolderQuery extends PaginatableQuery, SortableQuery {
  type: availableEntityFolderQueryType;
  excluded: number[];
  currentEntityFolderId: string|number|null;
}

export const encodeEntityFolderQuery = (query: EntityFolderQuery): Query => ({
  search: q.string(query.search),
  entityItem: q.numbers(query.entityItem),
  user: q.numbers(query.user),
  label: q.numbers(query.label),
});

export const encodeAvailableEntityFolderQuery = (query: ListAvailableEntityFolderQuery): Query => ({
  ...encodePaginatableQuery(query),
  type: q.string(query.type),
  excluded: q.numbers(query.excluded),
  currentEntityFolderId: query.currentEntityFolderId ? q.number(<number>query.currentEntityFolderId) : '',
  ...encodeSortableQuery(query),
});

export const entityFolderDefaultQuery = () => ({
  page: 1,
  perPage: 10000,
  search: '',
  entityItem: [],
  user: [],
  label: [],
  dir: '',
  sort: '',
});

export const availableEntityFolderDefaultQuery = (type: availableEntityFolderQueryType): ListAvailableEntityFolderQuery => ({
  page: 1,
  perPage: 10000,
  type,
  excluded: [],
  currentEntityFolderId: '',
  dir: '',
  sort: '',
});
